
  
  
  
  <ion-menu id="menuhide" side="start" menuId="custom" contentId="main" class="my-custom-menu" >
  <ion-header >
  <ion-toolbar class="new-background-color">
  <ion-title class="ion-text-center" style="color: white;"> Menu</ion-title>
  </ion-toolbar>
  </ion-header>
  <ion-content>
  <ion-list  *ngFor="let p of global.pages">

    <ion-menu-toggle auto-hide="false">  
      <ion-item [routerLink]="p.link"   routerDirection="forward" >  
        <ion-icon [name]="p.icon" item-left></ion-icon>  
        &nbsp;&nbsp;<span style="color:#337395">{{p.title}}</span>
      </ion-item>  
      <!-- <ion-item [routerLink]="['/driver-management']"   routerDirection="forward">  
        <ion-icon [name]="home" slot="start"></ion-icon>  
        DriverMangement 
      </ion-item> 
      <ion-item [routerLink]="['/dashboard']"   routerDirection="forward">  
        <ion-icon [name]="home" slot="start"></ion-icon>  
        Pending 
      </ion-item> 
      <ion-item [routerLink]="['/dashboard']"   routerDirection="forward">  
        <ion-icon [name]="home" slot="start"></ion-icon>  
        Live 
      </ion-item> 
      <ion-item [routerLink]="['/dashboard']"   routerDirection="forward">  
        <ion-icon [name]="home" slot="start"></ion-icon>  
        Completed 
      </ion-item>  -->
    </ion-menu-toggle> 
  </ion-list>
  </ion-content>
  </ion-menu>
  
  
  

  
  
  <ion-router-outlet id="main"></ion-router-outlet>